export const STUDIO_EVENT = {
  TOOL_VIEW: 'ai_tool_view',
  SETTINGS_INTERACTION: 'ai_settings_interaction',
  TRIAL_MODAL_VIEW: 'ai_trial_modal_view',
  REGISTRATION_MODAL_VIEW: 'ai_registration_modal_view',
  EDITING_FEATURE_OPEN: 'ai_editing_feature_open',
  GALLERY_VIEW: 'ai_gallery_view',
  MARKETPLACE_SUGGESTION_CLICK: 'ai_marketplace_suggestion_click',
  EXPORT_CLICK: 'ai_export_click',
  DCC_BRIDGE_CLICK: 'ai_dcc_bridge_click',
  SHARE_CLICK: 'ai_share_click',
  FEEDBACK_VIEW: 'ai_feedback_view',
  FEEDBACK_START: 'ai_feedback_start',
  FEEDBACK_SUBMIT: 'ai_feedback_submit',
}

// Plain function (not a hook) so module-level click handlers and Zustand store
// actions can track without hook plumbing. Pushes the site-wide GTMevent
// convention (same as Pods/Shared/Hooks/useTracker) via the global installed
// by the fast_navbar pack; no-ops during SSR and when GTM is not loaded.
export const trackStudioEvent = (name, eventData = {}) => {
  if (typeof window === 'undefined' || !window.customEventTracker) return

  window.customEventTracker({ name, eventData })
}

export const trackSettingsInteraction = (setting, value) => {
  trackStudioEvent(STUDIO_EVENT.SETTINGS_INTERACTION, { setting, value })
}
